module.exports = __webpack_public_path__ + "static/media/statsLoading.750b38b1.gif";